<script setup>
    import MainHeader from '@/components/shared/MainHeader';
    import Sidebar from '@/components/shared/Sidebar';

    const toggleSidebar = () => {
        const sidebar = document.getElementById('sidebar');
        const rootOverlay = document.getElementById('rootOverlay');
        sidebar.classList.toggle('opened');
        rootOverlay.classList.toggle('d-none');
    };
</script>

<template>
    <div class="app-wrapper">
        <Sidebar @toggle-sidebar="() => toggleSidebar()" />
        <div class="content">
            <MainHeader @toggle-sidebar="() => toggleSidebar()" />
            <div class="main-content">
                <router-view></router-view>
            </div>
        </div>
        <div id="rootOverlay" class="overlay d-none" @click="() => toggleSidebar()"></div>
    </div>
</template>

<style lang="scss">
    @import '@/styles/_gsb-variables.scss';

    .app-wrapper {
        height: 100%;

        .content {
            padding-top: $header-height;
            min-width: 1200px;

            .main-content {
                .main-content-header {
                    position: fixed;
                    left: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    color: #555;
                    padding: 0 1.5rem;
                    background-color: white;
                    border-bottom: 1px solid #ddd;
                    height: $main-content-header-height;
                    z-index: 999;

                    h1,
                    h2,
                    h3,
                    h4,
                    h5,
                    h6 {
                        margin-bottom: 0;

                        i {
                            vertical-align: middle;
                            margin-right: 0.25rem;
                        }
                    }
                }

                .main-content-body {
                    padding: ($main-content-header-height + 20px) 20px 20px;
                }
            }

            @media (min-width: 992px) {
                padding-left: $sidebar-width;
                .main-content .main-content-header {
                    left: $sidebar-width;
                }
            }
        }

        @media (max-width: 991px) {
            .overlay {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 999;
            }
        }
    }
</style>
